import { Help } from '@plasma/ui.application.app';

const help: Help[] = [
  // {
  //   title: 'ItemDocumentFinder',
  //   description: 'description of ItemDocumentFinder',
  //   url: '/item-document-finder',
  // },
];

export default help;
